const routes = [
  {
    index: true,
    label: "Aryan D Sheth",
    path: '/',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Tableau', 
    path: '/tableau',
  },
  {
    label: 'Blog',
    path: '/blogs',
  },
  {
    label: 'Feedbacks',
    path: '/feedbacks',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
